<script lang="ts" setup>
import {computed} from 'vue';
import {configuration} from "@Helpers/configuration";
import InputDecorator from './InputDecorator.vue';

const props = withDefaults(defineProps<{
    id: string,
    name: string,
    value: number,
    help?: string,
    errors?: string[],
    disabled?: boolean
}>(), {
    disabled: false,
    help: '',
    errors: () => []
});

const emit = defineEmits(['update']);

const computedValue = computed({
    get() {
        return props.value;
    },
    set(value) {
        emit('update', value);
    }
});

</script>
<template>
    <InputDecorator :for-id="id"  :help="help" :errors="errors">
        <div class="y-flex">
            <input type="text" class="form-control"
                   :id="id"
                   :name="name"
                   :disabled="disabled"
                   v-model="computedValue"
                   @change="(e: Event) => emit('update', (e.target as HTMLInputElement).value)"
            />
            <div class="y-py-0 y-px-3 y-bg-gray-100 y-border y-border-l-0 y-border-solid y-border-gray-200 y-rounded y-rounded-l-none y-flex y-items-center">
                <p class="y-text-gray-600 y-m-0">
                    {{ configuration.companyCurrencySymbol }}
                </p>
            </div>
        </div>
    </InputDecorator>
</template>